import HttpService from '../../../services/Http/HttpService';
import Logger from '../../../services/Logger/Logger';
import { API_ADMIN_FEEDBACKS } from './FeedbackConstant';
import { FeedbackResultsPojo } from './FeedbackResultsPojo';

export class FeedbackService {
    private httpService = new HttpService();
    private logger = new Logger();

    async getAll(): Promise<FeedbackResultsPojo> {
        try {
            const httpResult = await this.httpService.get(
                API_ADMIN_FEEDBACKS,
                {},
            );
            return {
                isSuccess: httpResult.data.isSuccess,
                feedbacks: httpResult.data.response,
                message: httpResult.data.messageForUser || '',
            };
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }

    async markAsRead(feedbackId: number): Promise<any> {
        try {
            const httpResult = await this.httpService.put(
                `${API_ADMIN_FEEDBACKS}/${feedbackId}/read`,
                {},
            );
            return {
                isSuccess: httpResult.data.isSuccess,
                message: httpResult.data.messageForUser || '',
            };
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }

    async reply(feedbackId: number, message: string): Promise<any> {
        try {
            const httpResult = await this.httpService.post(
                `${API_ADMIN_FEEDBACKS}/${feedbackId}/reply`,
                { message },
            );
            return {
                isSuccess: httpResult.data.isSuccess,
                message: httpResult.data.messageForUser || '',
            };
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }
}
